import { useState, createContext, useContext, useEffect, useRef } from "react";
import axios from "axios";
import { v4 as uuid } from "uuid";
import classNames from "classnames";
import { useTheme } from "@/comn/hooks";

const format = (param: any) => {
    return String(param).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const dictionary: any = {
    CGM: {
        VAR: "Vessel Arrival Report",
        AAR: "Aircraft Arrival Report",
        VDR: "Vessel Departure Report",
        ADP: "Aircraft Departure Report",
        ISM: "Import Sea Manifest",
        IAM: "Import Air Manifest",
        ITM: "Import Train Manifest",
        IRM: "Import Road Consignment Note",
        BTD: "BT Declaration",
        CDD: "ICD Declaration",
        STD: "Simple Transfer Declaration",
        SPD: "Simple Transfer Declaration (Post)",
        CRI_BL: "Carry-In Report (BL)",
        CRI_CNTR: "Carry-In Report (CNTR)",
        CRI_VHCL: "Carry-In Report (VHCL)",
        CIP: "Carry-In Report (Post)",
        HPR: "HandOver Report (Post)",
        CRO_BL: "Carry-Out Report (BL)",
        CRO_CNTR: "Carry-Out Report (CNTR)",
        CRO_VHCL: "Carry-Out Report (VHCL)",
        COP: "Carry-Out Report (Post)",
        OVER_CAG: "Overstayed Cargo",
        C2D: "C2 Delaration",
        SCN: "SCT Consignment Note",
        ENT: "Exit Note",
    },
    COL: { CLR_FEE: "TRA(Collection)" },
    CLR: {
        EX: "EXPORT",
        EX1: "XPORTATION",
        EX2: "TEMPORARY EXPORT",
        EX3: "RE-EXPORT",
        IM: "IMPORT",
        IM4: "ENTRY FOR HOME USE",
        IM5: "TEMPORARY IMPORTATION",
        IM6: "RE-IMPORTATION",
        IM7: "ENTRY FOR WAREHOUSING",
        IM8: "TRANSIT AND TRANSSHIPMENT",
        IM9: "OTHER IMPORT PROCEDURES",
    },
    ESA: {
        OGAZ0032: "Ministry of Agriculture, Irrigation, Natural Resources and Livestock (Agriculture)",
        OGAZ0033: "Ministry of Health - Zanzibar (Port Health)",
        OGAZ0034: "Zanzibar Control and Regulator Liquors Board",
        OGAZ0035: "Ministry of Trade and Investment Development",
        OGAM0011: "Tanzania Coffee Board",
        OGAM0012: "Tanzania Official Seed Certification Institute",
        OGAM0013: "Tanzania Medicines and Medical Devices Authority",
        OGAM0014: "Business Registration and Licensing Agency",
        OGAM0015: "Tanzania Wildlife Authority",
        OGAM0016: "Tanzania Atomic Energy Commission",
        OGAM0017: "Centre for Agricultural Mechanization and Rural Technology",
        OGAM0018: "Mining Commission",
        OGAM0019: "Tanzania Fertilizer Regulatory Authority",
        OGAM0020: "Tanzania Dairy Board",
        OGAM0021: "Tanzania Police Force",
        OGAM0022: "Tanzania Meat Board",
        OGAM0023: "Tanzania Investment Centre",
        OGAM0024: "Fair Competition Commission",
        OGAM0025: "Tanzania Ports Authority",
        OGAM0026: "Tanzania Immigration Department",
        OGAM0028: "Ministry of Agriculture",
        OGAM0029: "Cereal and Other Produce Regulatory Authority",
        OGAM0030: "Sugar Board of Tanzania",
        OGAM0032: "Tanzania Sisal Board",
        OGAM0033: "Tanzania Revenue Authority",
        OGAM0034: "Tanzania Shipping Agencies Corporation",
        OGAM0001: "Tanzania Bureau of Standards",
        OGAM0002: "Government Chemist Laboratory Authority",
        OGAM0003: "Tanzania Chamber of Commerce Industry and Agriculture",
        OGAM0004: "Tanzania Civil Aviation Authority",
        OGAM0005: "Tanzania Cotton Board",
        OGAM0006: "Tanzania Plant Health and Pesticides Authority",
        OGAM0008: "Tea Board of Tanzania",
        OGAM0007: "Tanzania Pyrethrum Board",
        OGAM0009: "Tanzania Tobacco Board",
        OGAM0010: "Cashewnut Board of Tanzania",
        OGAM0035: "Weights and Measures Agency",
        OGAZ0001: "Zanzibar Bureau of Standards",
        OGAM0036: "TANZANIA HARBOURS AUTHORITY",
        OGAM0038: "SURFACE & MARINE TRANSPORT REGULATORY AUTHORITY",
        OGAM0040: "TANZANIA FOOD AND DRUGS AUTHORITY (TFDA)",
        OGAM0041: "DR CONGO CUSTOMS",
        OGAM0042: "DEFAULT",
        OGAZ0002: "ZANZIBAR REVENUE BOARD",
        OGAZ0003: "ZANZIBAR PORTS CORPORATION",
        OGAZ0004: "ZANZIBAR REVENUE BOARD-PEMBA",
        OGAZ0005: "Zanzibar Food and Drugs Authority",
        OGAZ0008: "ZANZIBAR REVENUE BOARD",
        OGAZ0006: "ZANZIBAR REVENUE BOARD",
        OGAZ0007: "ZANZIBAR REVENUE BOARD",
        OGAZ0009: "The Zanzibar Utilities Regulatory Authority",
        OGAZ0010: "Zanzibar Food and Drug Agency",
        OGAZ0011: "Zanzibar Maritime Authority",
        OGAZ0012: "Chief Government Chemist Agency",
        OGAZ0014: "Tanzania Atomic Energy Commission",
        OGAZ0015: "Ministry of Blue Economy",
        OGAZ0016: "Zanzibar Airports Authority",
        OGAZ0017: "Zanzibar Investment Promotion Authority",
        OGAZ0018: "Zanzibar Ports Authority",
        OGAZ0019: "Zanzibar Revenue Authority",
        OGAZ0020: "Immigration Service Department-ZNZ",
        OGAZ0022: "Zanzibar Chamber of Commerce Industry and Agriculture",
        OGAZ0023: "KMKM",
        OGAZ0024: "Zanzibar Freight Fowarders",
        OGAZ0025: "Ministry of Infrastructure and Transport - Zanzibar",
        OGAZ0026: "Zanzibar Ports Cooperation",
        OGAZ0027: "Zanzibar Shipping and Planing",
        OGAZ0028: "Zanzibar Weights and Measures",
        OGAZ0029: "Ministry of Finance and Planning",
        OGAZ0030: "Ministry of Trade, Industry and Marketing",
        OGAZ0021: "Tanzania Police Force-ZNZ",
        OGAZ0031: "Zanzibar National Chamber of Commerce",
    },
};

const schema = {
    summary: [
        { name: "Arraival Report", bsopClsfCd: "CGM", bsopTpNm: ["VAR", "AAR"], type: 0 },
        { name: "Departure report", bsopClsfCd: "CGM", bsopTpNm: ["VDR", "ADP"], type: 0 },
        /* { name: "License", bsopClsfCd: "LCM", bsopTpNm: [], type: 0 }, */
        { name: "LPCO", bsopClsfCd: "ESA", bsopTpNm: [], type: 0 },
        { name: "Manifest", bsopClsfCd: "CGM", bsopTpNm: ["ISM", "IAM", "ITM", "IRM"], type: 0 },
        { name: "Transport", bsopClsfCd: "CGM", bsopTpNm: ["BTD", "CTD", "STD", "SPD"], type: 0 },
        { name: "Carry-in", bsopClsfCd: "CGM", bsopTpNm: ["CRI_BL", "CRI_VHCL", "CRI_CNTR", "CIP", "HPR"], type: 0 },
        {
            name: "Carry-out",
            bsopClsfCd: "CGM",
            bsopTpNm: ["CRO_BL", "CRO_VHCL", "CRO_CNTR", "COP", "OVER_CAG"],
            type: 0,
        },
        /* { name: "Etc", bsopClsfCd: "CGM", bsopTpNm: ["C2D", "SCN", "ENT"], type: 0 }, */
        { name: "TANSAD(IM)", bsopClsfCd: "CLR", bsopTpNm: ["IM", "IM4", "IM5", "IM6", "IM7", "IM8"], type: 0 },
        { name: "TANSAD(EX)", bsopClsfCd: "CLR", bsopTpNm: ["EX", "EX1", "EX2", "EX3"], type: 0 },
        { name: "TRA(Collection)", bsopClsfCd: "COL", bsopTpNm: [], type: 1 },
        /* { name: "OGA(Collection)", bsopClsfCd: "ESF", bsopTpNm: [], type: 1 }, */
        { name: "SCT", bsopClsfCd: "SCT", bsopTpNm: [], type: 0 },
    ],
    others: [
        { name: "Arraival Report", bsopClsfCd: "CGM", bsopTpNm: ["VAR", "AAR"], type: 0 },
        { name: "Departure report", bsopClsfCd: "CGM", bsopTpNm: ["VDR", "ADP"], type: 0 },
        /* { name: "License", bsopClsfCd: "LCM", bsopTpNm: [], type: 0 }, */
        { name: "LPCO", bsopClsfCd: "ESA", bsopTpNm: [], type: 0 },
        { name: "Manifest", bsopClsfCd: "CGM", bsopTpNm: ["ISM", "IAM", "ITM", "IRM"], type: 0 },
        { name: "Transport", bsopClsfCd: "CGM", bsopTpNm: ["BTD", "CTD", "STD", "SPD"], type: 0 },
        { name: "Carry-in", bsopClsfCd: "CGM", bsopTpNm: ["CRI_BL", "CRI_VHCL", "CRI_CNTR", "CIP", "HPR"], type: 0 },
        {
            name: "Carry-out",
            bsopClsfCd: "CGM",
            bsopTpNm: ["CRO_BL", "CRO_VHCL", "CRO_CNTR", "COP", "OVER_CAG"],
            type: 0,
        },
        /* { name: "Etc", bsopClsfCd: "CGM", bsopTpNm: ["C2D", "SCN", "ENT"], type: 0 }, */
        { name: "TANSAD(IM)", bsopClsfCd: "CLR", bsopTpNm: ["IM", "IM4", "IM5", "IM6", "IM7", "IM8"], type: 0 },
        { name: "TANSAD(EX)", bsopClsfCd: "CLR", bsopTpNm: ["EX", "EX1", "EX2", "EX3"], type: 0 },
        { name: "TRA(Bill amount)", bsopClsfCd: "COL", bsopTpNm: [], type: 1 },
        /* { name: "OGA(Bill amount)", bsopClsfCd: "ESF", bsopTpNm: [], type: 1 }, */
        { name: "TRA(Paid amount)", bsopClsfCd: "COL", bsopTpNm: [], type: 1 },
        /* { name: "OGA(Paid amount)", bsopClsfCd: "ESF", bsopTpNm: [], type: 1 }, */
        { name: "SCT", bsopClsfCd: "SCT", bsopTpNm: [], type: 0 },
    ],
};

const getSummary = (list: Array<any>) => {
    const result = [];
    for (let i = 0; i < schema.summary.length; i++) {
        const item = {
            name: schema.summary[i].name,
            doneCnt: 0,
            pndgCnt: 0,
            totCnt: 0,
            sumBllAmt: 0,
            sumRcptAmt: 0,
            today: 0,
            lastDay: 0,
            type: schema.summary[i].type,
        };
        for (let j = 0; j < list.length; j++) {
            if (
                list[j].bsopClsfCd === schema.summary[i].bsopClsfCd &&
                (schema.summary[i].bsopTpNm.length == 0 || schema.summary[i].bsopTpNm.indexOf(list[j].bsopTpNm) > -1)
            ) {
                item.doneCnt += list[j].doneCnt;
                item.pndgCnt += list[j].pndgCnt;
                item.totCnt += list[j].totCnt;
                item.sumBllAmt += list[j].sumBllAmt;
                item.sumRcptAmt += list[j].sumRcptAmt;
            }
        }
        result.push(item);
    }
    return result;
};

const getOthers = (list: Array<any>) => {
    const result = [];
    for (let i = 0; i < schema.others.length; i++) {
        const item = {
            name: schema.others[i].name,
            doneCnt: 0,
            pndgCnt: 0,
            totCnt: 0,
            sumBllAmt: 0,
            sumRcptAmt: 0,
            today: 0,
            lastDay: 0,
            type: schema.others[i].type,
        };
        for (let j = 0; j < list.length; j++) {
            if (
                list[j].bsopClsfCd === schema.others[i].bsopClsfCd &&
                (schema.others[i].bsopTpNm.length == 0 || schema.others[i].bsopTpNm.indexOf(list[j].bsopTpNm) > -1)
            ) {
                // 고지금액
                if (schema.others[i].name === "TRA(Bill amount)" || schema.others[i].name === "OGA(Bill amount)") {
                    item.today += list[j].currBllAmt;
                    item.lastDay += list[j].lastBllAmt;
                } else if (
                    schema.others[i].name === "TRA(Paid amount)" ||
                    schema.others[i].name === "OGA(Paid amount)"
                ) {
                    item.today += list[j].currRcptAmt;
                    item.lastDay += list[j].lastRcptAmt;
                } else {
                    item.today += list[j].currTotCnt;
                    item.lastDay += list[j].lastTotCnt;
                }
            }
        }
        result.push(item);
    }
    return result;
};

const Context = createContext<any>(null);

const ListContainer = ({ children }: any) => {
    const { screen } = useContext(Context);
    return (
        <div
            className={classNames(
                "w-full grid grid-cols-4 grid-rows-4 gap-5 flex-1",
                screen === "Summary" && "grid-rows-3",
            )}
        >
            {children}
        </div>
    );
};

const CardContainer = ({ children, ...props }: any) => {
    return (
        <div
            className="bg-card rounded-xl flex flex-col items-center px-5 pb-5 cursor-pointer transition-colors hover:bg-gray/5"
            {...props}
        >
            {children}
        </div>
    );
};

const DashboardList = () => {
    const { screen, data, setDetail2 } = useContext(Context);
    const isSummary = screen === "summary";
    const currentData = data[screen];
    const test = isSummary ? getSummary(currentData) : getOthers(currentData);

    if (isSummary)
        return (
            <ListContainer>
                {test.map((item: any) => {
                    const { name, totCnt, pndgCnt, doneCnt, type, sumBllAmt, sumRcptAmt } = item;

                    let text1: any;
                    let text2: any;
                    let text3: any;

                    let value1: any;
                    let value2: any;
                    let value3: any;
                    switch (type) {
                        case 0:
                            text1 = "Total count";
                            text2 = "Pending";
                            text3 = "Completed";
                            value1 = format(totCnt);
                            value2 = format(pndgCnt);
                            value3 = format(doneCnt);
                            break;
                        case 1:
                            text1 = "Total";
                            text2 = "Other amount";
                            text3 = "Oil amount";
                            value1 = format(sumBllAmt + sumRcptAmt);
                            value2 = format(sumBllAmt);
                            value3 = sumRcptAmt;
                            break;
                    }

                    return (
                        <CardContainer
                            key={uuid()}
                            onClick={() => {
                                setDetail2({
                                    ...item,
                                    _t1: text1,
                                    _t2: text2,
                                    _t3: text3,
                                    _v1: value1,
                                    _v2: value2,
                                    _v3: value3,
                                });
                            }}
                        >
                            <div className="font-bold text-[28px] flex-1 flex text-center items-center">{name}</div>
                            <div className="flex flex-col items-center gap-2 font-semibold text-[18px]">
                                <div className="flex text-tanesw">
                                    <div className="w-[120px]">{text1}</div>
                                    <div className="w-[240px]">: {value1}</div>
                                </div>
                                <div className="flex text-tancis-text">
                                    <div className="w-[120px]">{text2}</div>
                                    <div className="w-[240px]">: {value2}</div>
                                </div>
                                <div className="flex text-tanoga">
                                    <div className="w-[120px]">{text3}</div>
                                    <div className="w-[240px]">: {value3}</div>
                                </div>
                            </div>
                        </CardContainer>
                    );
                })}
            </ListContainer>
        );

    return (
        <ListContainer>
            {test.map((item: any) => {
                const { name, today, lastDay } = item;

                let thisTitle: any;
                let lastTitle: any;

                switch (screen) {
                    case "daily":
                        thisTitle = "Today";
                        lastTitle = "Last day";
                        break;
                    case "monthly":
                        thisTitle = "This month";
                        lastTitle = "Last month";
                        break;
                    case "annual":
                        thisTitle = "This year";
                        lastTitle = "Last year";
                        break;
                }

                let percent = lastDay == 0 ? 100 : ((today - lastDay) / lastDay) * 100 || 0;
                const status = percent === 0 || percent === 100 ? "default" : percent > 0 ? "up" : "down";
                percent = Math.abs(percent);

                let value1 = format(today);
                let value2 = format(lastDay);
                let value3 = format(percent.toFixed(0));

                return (
                    <CardContainer
                        key={uuid()}
                        onClick={() => {
                            setDetail2({
                                ...item,
                                _t1: thisTitle,
                                _t2: lastTitle,
                                _t3: "Percent",
                                _v1: value1,
                                _v2: value2,
                                _v3: value3,
                            });
                        }}
                    >
                        <div className="font-bold text-[28px] flex-1 flex text-center items-center">{name}</div>
                        <div className="flex flex-col items-center gap-2 font-semibold text-[18px]">
                            <div className="flex text-tanesw">
                                <div className="w-[120px]">{thisTitle}</div>
                                <div className="w-[240px]">: {format(today)}</div>
                            </div>
                            <div className="flex text-tancis-text">
                                <div className="w-[120px]">{lastTitle}</div>
                                <div className="w-[240px]">: {format(lastDay)}</div>
                            </div>
                            <div
                                className={classNames(
                                    "flex relative",
                                    status === "default" && "text-darkgray dark:text-lightgray",
                                    status === "up" && "text-tanoga",
                                    status === "down" && "text-red",
                                )}
                            >
                                <div className="w-[120px]">Percent</div>
                                <div className="w-[240px] flex items-center">
                                    : {format(percent.toFixed(0))}%
                                    <div className="">
                                        {status === "default" ? null : status === "up" ? (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={1.5}
                                                stroke="currentColor"
                                                className="size-5"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={1.5}
                                                stroke="currentColor"
                                                className="size-5"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181"
                                                />
                                            </svg>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CardContainer>
                );
            })}
        </ListContainer>
    );
};

const DashboardDetail = () => {
    const { data, setDetail2, screen, detail } = useContext(Context);
    const isSummary = screen === "summary";
    const currentData = data[screen];
    const currentSchema: any =
        schema[screen === "summary" ? "summary" : "others"].find(({ name }) => name === detail.name) || {};
    const { _t1, _t2, _t3, _v1, _v2, _v3 } = detail;
    const clsfCd = currentSchema.bsopClsfCd;
    const tpNm = currentSchema.bsopTpNm;
    const name = currentSchema.name;
    const list = currentData
        .filter(({ bsopClsfCd }: any) => {
            return bsopClsfCd === clsfCd;
        })
        .filter(({ bsopTpNm }: any) => {
            if (tpNm.length) {
                return tpNm.includes(bsopTpNm);
            } else {
                return true;
            }
        });

    const VALUE_VARS: any = {
        "TRA(Bill amount)": { v1: "currBllAmt", v2: "lastBllAmt" },
        "OGA(Bill amount)": { v1: "currBllAmt", v2: "lastBllAmt" },
        "TRA(Paid amount)": { v1: "currRcptAmt", v2: "lastRcptAmt" },
        "OGA(Paid amount)": { v1: "currRcptAmt", v2: "lastRcptAmt" },
        "TRA(Collection)": { v1: "sumRcptAmt", v2: "sumBllAmt" },
    };

    const VALUE_VAR = VALUE_VARS[name] || { v1: "currTotCnt", v2: "lastTotCnt" };

    console.log(name);

    return (
        <div className="w-full flex flex-col">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-8 mb-20 cursor-pointer"
                onClick={() => {
                    setDetail2(false);
                }}
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
            </svg>

            <div className="text-[28px] mb-5 ml-5">Statistic</div>
            <div className="flex border rounded-xl min-h-[200px] mb-20 bg-card">
                <div className="flex-1 flex flex-col items-center justify-center">
                    <div className="text-[28px]">{name}</div>
                </div>
                <div className="flex-1 flex flex-col items-center justify-center gap-2">
                    <div className="text-[24px]">{_t1}</div>
                    <div className="text-[40px] font-semibold text-tanesw">{_v1}</div>
                </div>
                <div className="flex-1 flex flex-col items-center justify-center gap-2">
                    <div className="text-[24px]">{_t2}</div>
                    <div className="text-[40px] font-semibold text-tancis-text">{_v2}</div>
                </div>
                <div className="flex-1 flex flex-col items-center justify-center gap-2">
                    <div className="text-[24px]">{_t3}</div>
                    <div className="text-[40px] font-semibold text-tanoga">{_v3}</div>
                </div>
            </div>
            <div className="text-[28px] mb-5 ml-5">Detail</div>
            <div className="border rounded-t-xl rounded-b-xl overflow-hidden">
                <table className="w-full [&_tr]:h-[48px] [&_th]:p-3 [&_td]:p-3 text-[16px]">
                    <thead className="bg-header">
                        <tr>
                            <th>Name</th>
                            <th>{_t1}</th>
                            <th>{_t2}</th>
                            <th>{_t3}</th>
                        </tr>
                    </thead>
                    <tbody className="bg-card">
                        {list.map((item: any) => {
                            console.log(item);
                            console.log(VALUE_VAR);
                            console.log(isSummary);
                            const { bsopClsfCd, bsopTpNm, pndgCnt, doneCnt, totCnt } = item;

                            let v2 = isSummary ? pndgCnt : item[VALUE_VAR.v1];
                            let v3 = isSummary ? doneCnt : item[VALUE_VAR.v2];
                            let v1 = isSummary
                                ? format(totCnt)
                                : v3 == 0
                                  ? 100
                                  : (((v2 - v3) / v3) * 100 || 0).toFixed(0);

                            if (isSummary == true && name == "TRA(Collection)") {
                                v2 = item[VALUE_VAR.v2];
                                v3 = item[VALUE_VAR.v1];
                                v1 = v2 + v3;
                            }

                            if (isSummary == true && name == "SCT") {
                                v2 = 0;
                                v3 = 0;
                                v1 = totCnt;
                            }

                            return (
                                <tr key={uuid()} className="even:bg-gray/5">
                                    <td>{dictionary[bsopClsfCd] ? dictionary[bsopClsfCd][bsopTpNm] : bsopTpNm}</td>
                                    <td className="text-center">{format(v1)}</td>
                                    <td className="text-center">{format(v2)}</td>
                                    <td className="text-center">{v3}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const DashboardHomeToggle = () => {
    const { toggleHome } = useContext(Context);
    return (
        <button
            onClick={toggleHome}
            type="button"
            className="border rounded-lg p-2 bg-header hover:bg-gray/5 transition-colors"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="size-6"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                />
            </svg>
        </button>
    );
};

const DashboardScreenToggle = () => {
    const { toggle } = useContext(Context);
    return (
        <button
            onClick={toggle}
            type="button"
            className="border rounded-lg p-2 bg-header hover:bg-gray/5 transition-colors"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                />
            </svg>
        </button>
    );
};

const DashboardThemeToggle = () => {
    const {
        theme: { isDark },
        setTheme,
    } = useTheme();
    return (
        <button
            onClick={() => setTheme((prev) => ({ ...prev, isDark: prev.isDark === "true" ? "false" : "true" }))}
            type="button"
            className="border rounded-lg p-2 bg-header hover:bg-gray/5 transition-colors"
        >
            {isDark === "true" ? (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                    />
                </svg>
            ) : (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
                    />
                </svg>
            )}
        </button>
    );
};

const DashboardControls = () => {
    return (
        <div className="absolute top-0 right-0 flex gap-2">
            <DashboardHomeToggle />
            <DashboardScreenToggle />
            <DashboardThemeToggle />
        </div>
    );
};

const DashboardHeader = () => {
    const { screen, setScreen2 } = useContext(Context);

    const CYCLES = [
        { name: "Daily", dataVar: "daily" },
        { name: "Monthly", dataVar: "monthly" },
        { name: "Annual", dataVar: "annual" },
    ];

    if (screen === "summary")
        return (
            <h1 className="flex items-center border-b-2 border-text h-[60px] text-[40px] mb-20 font-[500]">
                Summary of daily
            </h1>
        );

    return (
        <div className="flex items-center h-[60px] gap-20 text-[40px] mb-20 font-[500]">
            {CYCLES.map(({ name, dataVar }) => {
                return (
                    <button
                        aria-current={dataVar === screen}
                        key={uuid()}
                        className="text-lightgray border-b-2 border-transparent aria-[current=true]:text-text aria-[current=true]:border-text"
                        type="button"
                        onClick={() => {
                            setScreen2(dataVar);
                        }}
                    >
                        {name}
                    </button>
                );
            })}
        </div>
    );
};

const Dashboard = () => {
    const _dashboard = useRef({ detail: false }).current;
    const SCREENS = ["summary", "daily", "monthly", "annual"];
    const [screen, setScreen] = useState("summary");
    const [detail, setDetail] = useState(false);
    const [data, setData] = useState({ summary: [], daily: [], monthly: [], annual: [] });

    const toggle = () => {
        setDetail2(false);
        setScreen((prev: any) => {
            const prevIndex = SCREENS.findIndex((item: any) => item === prev);
            const nextIndex = prevIndex + 1 > SCREENS.length - 1 ? 0 : prevIndex + 1;
            return SCREENS[nextIndex];
        });
    };

    const toggleHome = () => {
        setDetail2(false);
        setScreen(SCREENS[0]);
    };

    const setScreen2 = (value: any) => {
        setDetail2(false);
        setScreen(value);
    };

    const setDetail2 = (value: any) => {
        _dashboard.detail = value;
        setDetail(value);
    };

    const getDashboardData = async () => {
        try {
            const base = process.env.REACT_APP_API_PTLI;
            const path = "/api/v1/ptl/dshbrd/list";
            const {
                data: {
                    data: { content },
                },
            } = await axios.get(base + path);
            setData(content);
        } catch (error) {
            console.log(error);
        }
    };

    // 10분마다 데이터가져오기
    useEffect(() => {
        getDashboardData();
        const intervalId = setInterval(() => {
            getDashboardData();
        }, 600000);
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    // 30초마다 화면바꾸기
    // useEffect(() => {
    //     const intervalId = setInterval(() => {
    //         if (!_dashboard.detail) toggle();
    //     }, 30000);
    //     return () => {
    //         clearInterval(intervalId);
    //     };
    // }, []);

    return (
        <Context.Provider value={{ screen, setScreen2, toggle, toggleHome, data, setDetail2, detail }}>
            <div className="w-screen min-h-screen flex justify-center p-20 tracking-wide">
                <div className="relative flex-1 max-w-[1880px]">
                    <DashboardControls />
                    <div className="h-full flex flex-col items-center">
                        <DashboardHeader />
                        {detail ? <DashboardDetail /> : <DashboardList />}
                    </div>
                </div>
            </div>
        </Context.Provider>
    );
};

export default Dashboard;
